import {
  HttpContext,
  HttpContextToken,
  HttpInterceptorFn
} from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoaderService } from "../../services/loader/loader.service";

export const SHOW_LOADER = new HttpContextToken(() => true);

export function getContext(showLoader = true): HttpContext | undefined {
  return showLoader ? undefined : new HttpContext().set(SHOW_LOADER, false);
}

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  const showLoader = req.context.get(SHOW_LOADER);
  if (!showLoader) {
    return next(req);
  }

  loaderService.addRequest();
  return next(req).pipe(
    finalize(() => {
      loaderService.removeRequest();
    })
  );
};
